/* Built In Imports */
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/**
 * @description Renders the Yantra Footer component.
 * @param {Array} footerData
 * @returns {ReactElement} Yantra Footer Social Media component.
 */
const YantraSocialMedia = ({ secData, pageData }) => {
  const footer = pageData?.body.find(el => el.sectionId == secData);
  const footerData = footer?.sectionContent;
  // debugger;
  const iconBlock = contentobj => {
    return (
      <Link href={refineUrlDomain(contentobj?.linkUrl)} target="_blank">
        <Image
          src={contentobj?.image?.url}
          alt={contentobj?.image?.alt}
          title={contentobj?.image?.title}
          mx="10px"
          bgColor="#fff"
          borderRadius="50%"
        />
      </Link>
    );
  };
  return (
    <>
      {footerData.length > 0 && (
        <Box
          textAlign="center"
          color="#fff"
          width={{ base: '100%', md: '50%' }}
          mx="auto"
          my="50px"
          position="relative"
          _after={{
            content: '" "',
            position: 'absolute',
            right: '2px',
            borderBottom: {
              base: 'solid 1px #fff',
              md: 'solid 1px #fff',
            },
            borderRight: { base: 'none', md: 'solid 1px #fff' },
            top: { base: '115%', md: '0' },
            height: { base: '0%', md: '100%' },
            width: { base: '100%', md: 'auto' },
          }}
        >
          <Box maxW="365px" mx="auto">
            <Text
              as="h1"
              color="#fff"
              fontSize={{
                base: '27px',
                md: '32px',
              }}
              mb="12px"
            >
              {footerData[0]?.titleText}
            </Text>
            <Image
              src={`${config.imgPath}/d/46272/1656741032-divider_yellow.png`}
              alt="divider"
              title="Divider"
              mb={{ base: '30px', md: '60px' }}
            />
            <Text fontFamily="FedraSansStd-medium" fontSize="16px" mb="30px">
              {footerData[1]?.text}
            </Text>
            <Flex alignItems="center" justifyContent="center" mb="20px">
              {iconBlock(footerData[2])}
              {iconBlock(footerData[3])}
              {iconBlock(footerData[4])}
            </Flex>
            <Text
              fontFamily="FedraSansStd-book"
              fontSize="16px"
              mb="50px"
              lineHeight="25px"
            >
              {footerData[5]?.text}
            </Text>
            <Link
              href={refineUrlDomain(footerData[6]?.linkUrl)}
              background="#FFF9E8"
              borderRadius="4px"
              color="#28231E"
              fontSize="16px"
              padding="14px 30px"
              fontFamily="FedraSansStd-medium"
              target="_blank"
              _hover={{
                textDecoration: 'none',
              }}
            >
              {footerData[6]?.buttonText}
            </Link>
          </Box>
        </Box>
      )}
    </>
  );
};

export default YantraSocialMedia;
